<template>
  <div>
    <div id="map"></div>
  </div>
</template>

<script>
export default {
  name: "LocalMap",
  props:['autoload'],
  watch: {
    '$store.state.emplacementsMap': function() {
      this.$store.dispatch("loadDataOnMap");
    }
  },
  mounted: function () {
    this.$store.dispatch("initMap");
    if(this.autoload === true){
      this.$store.dispatch("fetchEmplacements");
    }
  },
  computed: {
    emplacementsMap: function() {
      return this.$store.state.emplacementsMap;
    }
  }
};
</script>
